import React, { useState, useRef, useEffect } from "react";
import { ProgressBar } from "react-bootstrap";
import Logo from "../../assets/logo.svg";
import QuizModule from "./QuizModule";
import { useSelector } from "react-redux";
import { selectCurrentLanguage } from "../../features/langSlice";
import { ToastContainer } from "react-toastify";
import { Icon } from "../../Components/elements/icon";
import { useNavigate, useSearchParams } from "react-router-dom";
import FirstSlide from "./FirstSlide";
import useMeta from "../../hooks/useMeta";

const Quiz = () => {
  const [searchParams] = useSearchParams();
  const quizId = searchParams.get("quizId");

  const previousRef = useRef();
  const [showProgressBar, setShowProgressBar] = useState(true);

  const selectedLang = useSelector(selectCurrentLanguage);
  const [lang, setLang] = useState("en");

  const [progressValue, setProgressValue] = useState(0);

  useEffect(() => {
    setLang(selectedLang === "us" ? "en" : selectedLang);
  }, [lang, selectedLang]);

  const [firstSlide, setFirstSlide] = useState(true);
  const history = useNavigate();
  const previousHandle = () => {
    if (firstSlide) {
      history(-1);
    } else {
      if (previousRef.current) {
        previousRef.current.handlePrevious();
      }
    }
  };

  const { metaEvent } = useMeta();

  const handleClickFirstSlide = () => {
    setFirstSlide(false);
    metaEvent("LandingQuiz");
  };

  return (
    <div>
      <div className="quiz t-bg-white">
        <div className="d-flex justify-content-between w-100 align-items-center">
          <div className="col-3 ps-2 me-auto">
            <Icon
              name="chevronLeft"
              color="#000"
              onClick={previousHandle}
              size="32"
            />
          </div>
          <div className="col-md-6 col-sm-4 text-center mx-md-auto">
            <img src={Logo} alt="" width={100} className="t-mx-auto" />
          </div>
          <div className="col-3 ps-2 ms-auto">&nbsp;</div>
        </div>
        {firstSlide && !quizId ? (
          <FirstSlide handleClick={handleClickFirstSlide} />
        ) : (
          <>
            <div className="t-flex t-flex-col t-gap-0 t-my-8">
              {showProgressBar && (
                <ProgressBar
                  className="custom-progress-bar !t-mx-auto !t-w-[90%] md:!t-w-[500px] !t-border-[1px] !t-border-secondary !t-bg-[#f2f4f7]"
                  style={{ width: "90%", height: "10px" }}
                  now={progressValue}
                />
              )}
              {showProgressBar && (
                <div className="progressbar-label !t-mx-auto !t-w-full !t-text-black !t-text-center">{`${progressValue}%`}</div>
              )}
            </div>
            <div className="container">
              <QuizModule
                setProgressValue={setProgressValue}
                ref={previousRef}
                setShowProgressBar={setShowProgressBar}
                progressValue={progressValue}
                firstSlide={firstSlide}
                setFirstSlide={setFirstSlide}
              />
              <div style={{ height: "100%" }}>&nbsp;</div>
            </div>
          </>
        )}
      </div>
      <ToastContainer />
    </div>
  );
};

export default Quiz;
